<div class="hero">
    <div class="hero-image-container">
        <img
            [src]="imagePath()"
            class="hero-image"
            [ngClass]="'image-align-' + imageAlign()"
            [alt]="imageAlt()"
            [attr.role]="imageAlt() ? 'img' : 'presentation'"
            [title]="imageAlt()"
        />
        @if (textInImage()) {
            <div class="content-container">
                <h1
                    class="strong fs:xl"
                    [innerHTML]="textInImage()"
                ></h1>
            </div>
        }
    </div>
    @if (headline()) {
        <div class="hero-text-box">
            <div class="content-container">
                <div class="grid-container">
                    <div
                        class="g-12 hero-text-box-content"
                        [innerHtml]="headline()"
                    ></div>
                </div>
            </div>
        </div>
    }
</div>
